import { CARD_GRID } from "../../../../../../components/LayoutFactory/constants";

export const DISCOVERY_LAYOUT = {
    name: CARD_GRID,
    columns: 5,
    isFlexible: true,
};
